// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

navigator.serviceWorker.getRegistrations().then(function(registrations) {
  for (let registration of registrations) {
    registration.unregister()
  }
})


navigator.serviceWorker.getRegistrations().then(function(registrations) {
  for (let registration of registrations) {
    registration.unregister()
  }
})

function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}

var HOW_TO_FABRIC_ICONS = [
  "Home",
  "PageAdd",
  "KnowledgeArticle",
  "ReportDocument",
  "Permissions",
  "LaptopSelected",
  "Ticket",
  "BulletedList",
  "TaskManager",
  "Upload",
  "CloudUpload",
  "Link",
  "Search",
  "Add",
  "CheckMark",
  "StatusCircleCheckmark",
  "Warning",
  "WarningSolid",
  "Info",
  "InfoSolid",
  "MapPin",
  "Location",
  "Camera",
  "Video",
  "Photo2",
  "Picture",
  "OpenFile",
  "FolderOpen",
  "Preview",
  "NavigateExternalInline",
  "Phone",
  "MobileSelected",
  "Clock",
  "World",
  "FavoriteStar",
  "Shield"
]

function renderHowToIconOptions(selectedValue) {
  return HOW_TO_FABRIC_ICONS.map(function(iconName) {
    return `<option value="${iconName}" ${selectedValue === iconName ? "selected" : ""}>${iconName}</option>`
  }).join("")
}

function renderHowToIconPreview(iconValue, iconLabel) {
  if (HOW_TO_FABRIC_ICONS.indexOf(iconValue) >= 0) {
    return `<span class="ms-Icon ms-Icon--${escapeHtml(iconValue)}"></span>`
  }

  if (iconLabel) {
    return `<span>${escapeHtml(iconLabel)}</span>`
  }

  if (iconValue) {
    return `<span>${escapeHtml(iconValue)}</span>`
  }

  return `<span class="howto-builder-icon-preview__placeholder">No icon</span>`
}

function defaultSection(kind) {
  if (kind === "steps") {
    return {
      kind: "steps",
      title: "Steps",
      body: "",
      items: [{ title: "", body: "" }]
    }
  }

  if (kind === "info_cards") {
    return {
      kind: "info_cards",
      title: "Info Cards",
      body: "",
      items: [{ title: "", body: "", icon: "", icon_label: "" }]
    }
  }

  if (kind === "callout") {
    return {
      kind: "callout",
      title: "Callout",
      body: "",
      badge: "",
      tone: "info"
    }
  }

  return {
    kind: "video_gallery",
    title: "Training Videos",
    body: "",
    items: [{ title: "", description: "", embed_html: "", link_label: "", link_url: "" }]
  }
}

function renderSectionItems(section) {
  var items = Array.isArray(section.items) ? section.items : []

  if (section.kind === "steps") {
    return items.map(function(item, itemIndex) {
      return `
        <div class="howto-builder-list-item" data-howto-item="${itemIndex}">
          <div class="form-row">
            <div class="form-group col-md-5 mb-2">
              <label>Step title</label>
              <input type="text" class="form-control" data-field="title" value="${escapeHtml(item.title)}">
            </div>
            <div class="form-group col-md-6 mb-2">
              <label>Step text</label>
              <textarea class="form-control" rows="2" data-field="body">${escapeHtml(item.body)}</textarea>
            </div>
            <div class="form-group col-md-1 mb-2 d-flex align-items-end">
              <button type="button" class="btn btn-outline-danger btn-sm btn-block" data-howto-remove-item="${itemIndex}">×</button>
            </div>
          </div>
        </div>
      `
    }).join("")
  }

  if (section.kind === "info_cards") {
    return items.map(function(item, itemIndex) {
      return `
        <div class="howto-builder-list-item" data-howto-item="${itemIndex}">
          <div class="form-row">
            <div class="form-group col-md-4 mb-2">
              <label>Card title</label>
              <input type="text" class="form-control" data-field="title" value="${escapeHtml(item.title)}">
            </div>
            <div class="form-group col-md-3 mb-2">
              <label>Fabric icon</label>
              <input type="text" class="form-control mb-2" data-field="icon" value="${escapeHtml(item.icon)}" placeholder="Search icon name" list="howto-fabric-icons-list">
              <div class="howto-builder-icon-preview">
                ${renderHowToIconPreview(item.icon, item.icon_label)}
              </div>
            </div>
            <div class="form-group col-md-4 mb-2">
              <label>Card text</label>
              <textarea class="form-control" rows="2" data-field="body">${escapeHtml(item.body)}</textarea>
            </div>
            <div class="form-group col-md-1 mb-2 d-flex align-items-end">
              <button type="button" class="btn btn-outline-danger btn-sm btn-block" data-howto-remove-item="${itemIndex}">×</button>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4 mb-0">
              <label>Fallback short label</label>
              <input type="text" class="form-control" data-field="icon_label" value="${escapeHtml(item.icon_label)}" placeholder="Optional text or emoji">
            </div>
          </div>
        </div>
      `
    }).join("")
  }

  if (section.kind === "video_gallery") {
    return items.map(function(item, itemIndex) {
      return `
        <div class="howto-builder-list-item" data-howto-item="${itemIndex}">
          <div class="form-row">
            <div class="form-group col-md-5 mb-2">
              <label>Video title</label>
              <input type="text" class="form-control" data-field="title" value="${escapeHtml(item.title)}">
            </div>
            <div class="form-group col-md-6 mb-2">
              <label>Description</label>
              <textarea class="form-control" rows="2" data-field="description">${escapeHtml(item.description)}</textarea>
            </div>
            <div class="form-group col-md-1 mb-2 d-flex align-items-end">
              <button type="button" class="btn btn-outline-danger btn-sm btn-block" data-howto-remove-item="${itemIndex}">×</button>
            </div>
          </div>
          <div class="form-group mb-2">
            <label>Embed HTML</label>
            <textarea class="form-control" rows="4" data-field="embed_html" placeholder="<iframe ...></iframe>">${escapeHtml(item.embed_html)}</textarea>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4 mb-0">
              <label>Optional link label</label>
              <input type="text" class="form-control" data-field="link_label" value="${escapeHtml(item.link_label)}">
            </div>
            <div class="form-group col-md-8 mb-0">
              <label>Optional link URL</label>
              <input type="text" class="form-control" data-field="link_url" value="${escapeHtml(item.link_url)}">
            </div>
          </div>
        </div>
      `
    }).join("")
  }

  return ""
}

function renderSection(section, index) {
  var baseFields = `
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>Section type</label>
        <select class="form-control" data-howto-section-kind>
          <option value="steps" ${section.kind === "steps" ? "selected" : ""}>Steps</option>
          <option value="info_cards" ${section.kind === "info_cards" ? "selected" : ""}>Info Cards</option>
          <option value="callout" ${section.kind === "callout" ? "selected" : ""}>Callout</option>
          <option value="video_gallery" ${section.kind === "video_gallery" ? "selected" : ""}>Video Gallery</option>
        </select>
      </div>
      <div class="form-group col-md-8">
        <label>Section title</label>
        <input type="text" class="form-control" data-field="title" value="${escapeHtml(section.title)}">
      </div>
    </div>
  `

  var bodyField = `
    <div class="form-group">
      <label>Section intro text</label>
      <textarea class="form-control" rows="2" data-field="body">${escapeHtml(section.body)}</textarea>
    </div>
  `

  var kindSpecific = ""
  if (section.kind === "callout") {
    kindSpecific = `
      <div class="form-row">
        <div class="form-group col-md-5">
          <label>Badge</label>
          <input type="text" class="form-control" data-field="badge" value="${escapeHtml(section.badge)}" placeholder="ADMIN">
        </div>
        <div class="form-group col-md-4">
          <label>Tone</label>
          <select class="form-control" data-field="tone">
            <option value="info" ${section.tone === "info" ? "selected" : ""}>Info</option>
            <option value="admin" ${section.tone === "admin" ? "selected" : ""}>Admin</option>
            <option value="warning" ${section.tone === "warning" ? "selected" : ""}>Warning</option>
            <option value="success" ${section.tone === "success" ? "selected" : ""}>Success</option>
          </select>
        </div>
      </div>
    `
  } else {
    kindSpecific = `
      <div class="howto-builder-list">
        ${renderSectionItems(section)}
      </div>
      <button type="button" class="btn btn-outline-primary btn-sm mt-3" data-howto-add-item="${index}">
        Add item
      </button>
    `
  }

  return `
    <div class="howto-builder-section" data-howto-section="${index}" draggable="true">
      <div class="howto-builder-section__top">
        <div class="howto-builder-section__heading">
          <button type="button" class="howto-builder-section__drag" data-howto-drag-handle aria-label="Drag to reorder section" title="Drag to reorder section">
            ≡
          </button>
          <strong>Section ${index + 1}</strong>
        </div>
        <button type="button" class="btn btn-outline-danger btn-sm" data-howto-remove-section="${index}">Remove section</button>
      </div>
      ${baseFields}
      ${bodyField}
      ${kindSpecific}
    </div>
  `
}

function normalizeBuilderState(builder) {
  var sections = []

  builder.querySelectorAll("[data-howto-section]").forEach(function(sectionNode) {
    var kind = sectionNode.querySelector("[data-howto-section-kind]").value
    var section = {
      kind: kind,
      title: (sectionNode.querySelector('[data-field="title"]') || {}).value || "",
      body: (sectionNode.querySelector('[data-field="body"]') || {}).value || ""
    }

    if (kind === "callout") {
      section.badge = (sectionNode.querySelector('[data-field="badge"]') || {}).value || ""
      section.tone = (sectionNode.querySelector('[data-field="tone"]') || {}).value || "info"
    } else {
      section.items = []
      sectionNode.querySelectorAll("[data-howto-item]").forEach(function(itemNode) {
        var item = {}
        itemNode.querySelectorAll("[data-field]").forEach(function(fieldNode) {
          item[fieldNode.dataset.field] = fieldNode.value || ""
        })
        section.items.push(item)
      })
    }

    sections.push(section)
  })

  return sections
}

function initHowToBuilder() {
  document.querySelectorAll("[data-howto-builder]").forEach(function(builder) {
    var form = builder.closest("form")
    var hiddenInput = form ? form.querySelector("[data-howto_sections_payload], [data-howto-sections-payload]") : null
    var sections
    var draggedSectionIndex = null

    function loadSectionsFromSource() {
      var payload = hiddenInput && hiddenInput.value ? hiddenInput.value : "[]"

      try {
        var parsed = JSON.parse(payload)
        return Array.isArray(parsed) ? parsed : []
      } catch (error) {
        return []
      }
    }

    sections = loadSectionsFromSource()

    if (!Array.isArray(sections) || sections.length === 0) {
      sections = [defaultSection("steps")]
    }

    function syncHiddenField() {
      if (hiddenInput) hiddenInput.value = JSON.stringify(sections)
    }

    function render() {
      builder.innerHTML = `<datalist id="howto-fabric-icons-list">${HOW_TO_FABRIC_ICONS.map(function(iconName) {
        return `<option value="${iconName}"></option>`
      }).join("")}</datalist>` + sections.map(renderSection).join("")
      syncHiddenField()
    }

    render()

    if (builder.dataset.bound === "true") {
      return
    }

    builder.dataset.bound = "true"

    var addSectionButton = document.querySelector("[data-howto-add-section]")
    if (addSectionButton) {
      addSectionButton.addEventListener("click", function() {
        sections = normalizeBuilderState(builder)
        sections.push(defaultSection("steps"))
        render()
      })
    }

    builder.addEventListener("input", function() {
      sections = normalizeBuilderState(builder)
      syncHiddenField()

      var activeItem = document.activeElement.closest("[data-howto-item]")
      if (activeItem) {
        var preview = activeItem.querySelector(".howto-builder-icon-preview")
        if (preview) {
          var iconValue = (activeItem.querySelector('[data-field="icon"]') || {}).value || ""
          var iconLabel = (activeItem.querySelector('[data-field="icon_label"]') || {}).value || ""
          preview.innerHTML = renderHowToIconPreview(iconValue, iconLabel)
        }
      }
    })

    builder.addEventListener("change", function(event) {
      if (event.target.matches("[data-howto-section-kind]")) {
        sections = normalizeBuilderState(builder)
        var sectionNode = event.target.closest("[data-howto-section]")
        var sectionIndex = Number(sectionNode.dataset.howtoSection)
        sections[sectionIndex] = defaultSection(event.target.value)
        render()
        return
      }

      sections = normalizeBuilderState(builder)
      syncHiddenField()
    })

    builder.addEventListener("click", function(event) {
      var removeSectionButton = event.target.closest("[data-howto-remove-section]")
      var addItemButton = event.target.closest("[data-howto-add-item]")
      var removeItemButton = event.target.closest("[data-howto-remove-item]")

      if (removeSectionButton) {
        sections = normalizeBuilderState(builder)
        sections.splice(Number(removeSectionButton.dataset.howtoRemoveSection), 1)
        if (sections.length === 0) sections.push(defaultSection("steps"))
        render()
      }

      if (addItemButton) {
        sections = normalizeBuilderState(builder)
        var section = sections[Number(addItemButton.dataset.howtoAddItem)]
        if (section.kind === "steps") section.items.push({ title: "", body: "" })
        if (section.kind === "info_cards") section.items.push({ title: "", body: "", icon: "", icon_label: "" })
        if (section.kind === "video_gallery") section.items.push({ title: "", description: "", embed_html: "", link_label: "", link_url: "" })
        render()
      }

      if (removeItemButton) {
        sections = normalizeBuilderState(builder)
        var sectionNode = removeItemButton.closest("[data-howto-section]")
        var itemIndex = Number(removeItemButton.dataset.howtoRemoveItem)
        var targetSection = sections[Number(sectionNode.dataset.howtoSection)]
        targetSection.items.splice(itemIndex, 1)
        if (targetSection.items.length === 0) {
          if (targetSection.kind === "steps") targetSection.items.push({ title: "", body: "" })
          if (targetSection.kind === "info_cards") targetSection.items.push({ title: "", body: "", icon: "", icon_label: "" })
          if (targetSection.kind === "video_gallery") targetSection.items.push({ title: "", description: "", embed_html: "", link_label: "", link_url: "" })
        }
        render()
      }
    })

    builder.addEventListener("dragstart", function(event) {
      var sectionNode = event.target.closest("[data-howto-section]")
      if (!sectionNode) return

      draggedSectionIndex = Number(sectionNode.dataset.howtoSection)
      event.dataTransfer.effectAllowed = "move"
      event.dataTransfer.setData("text/plain", String(draggedSectionIndex))
      sectionNode.classList.add("howto-builder-section--dragging")
    })

    builder.addEventListener("dragend", function() {
      draggedSectionIndex = null
      builder.querySelectorAll(".howto-builder-section").forEach(function(node) {
        node.classList.remove("howto-builder-section--dragging", "howto-builder-section--drop-target")
      })
    })

    builder.addEventListener("dragover", function(event) {
      var sectionNode = event.target.closest("[data-howto-section]")
      if (!sectionNode || draggedSectionIndex === null) return

      event.preventDefault()
      builder.querySelectorAll(".howto-builder-section").forEach(function(node) {
        node.classList.remove("howto-builder-section--drop-target")
      })
      sectionNode.classList.add("howto-builder-section--drop-target")
      event.dataTransfer.dropEffect = "move"
    })

    builder.addEventListener("drop", function(event) {
      var sectionNode = event.target.closest("[data-howto-section]")
      if (!sectionNode || draggedSectionIndex === null) return

      event.preventDefault()
      sections = normalizeBuilderState(builder)

      var targetIndex = Number(sectionNode.dataset.howtoSection)
      if (targetIndex === draggedSectionIndex) {
        sectionNode.classList.remove("howto-builder-section--drop-target")
        return
      }

      var movedSection = sections.splice(draggedSectionIndex, 1)[0]
      sections.splice(targetIndex, 0, movedSection)
      render()
    })

    if (form) {
      form.addEventListener("submit", function() {
        sections = normalizeBuilderState(builder)
        syncHiddenField()
      })
    }
  })
}

function initCopyUrlButtons() {
  document.querySelectorAll("[data-copy-url-button]").forEach(function(button) {
    if (button.dataset.bound === "true") return
    button.dataset.bound = "true"

    button.addEventListener("click", function() {
      var path = button.dataset.copyUrlPath || ""
      var url = window.location.origin + path
      var originalText = button.textContent

      function showCopiedState() {
        button.textContent = "Copied!"
        button.classList.add("howto-copy-button--copied")
        window.setTimeout(function() {
          button.textContent = originalText
          button.classList.remove("howto-copy-button--copied")
        }, 1400)
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(showCopiedState).catch(function() {
          button.textContent = url
        })
        return
      }

      var tempInput = document.createElement("input")
      tempInput.value = url
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand("copy")
      document.body.removeChild(tempInput)
      showCopiedState()
    })
  })
}

document.addEventListener("turbolinks:before-cache", function() {
  document.querySelectorAll("[data-howto-builder]").forEach(function(builder) {
    var form = builder.closest("form")
    var hiddenInput = form ? form.querySelector("[data-howto_sections_payload], [data-howto-sections-payload]") : null

    if (hiddenInput && builder.querySelector("[data-howto-section]")) {
      hiddenInput.value = JSON.stringify(normalizeBuilderState(builder))
    }
  })
})

document.addEventListener("turbolinks:load", initHowToBuilder)
document.addEventListener("turbolinks:load", initCopyUrlButtons)
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
